export default __webpack_public_path__ + "static/media/information--street-name-two-lines--g1.9fdf4282.png";